import { useRestQuery } from 'utils/hooks/api/useRestQuery';

const FACEBOOK_AD_ACCOUNT_URL = '/integrations/getAllAdAccounts';

type AdAccountRequest = {
  code: string;
};

type AdAccountResponse = string[];

export const useGetAllAdAccounts = (code = '') => {
  const {
    data = [],
    isLoading,
    isError,
    isSuccess,
  } = useRestQuery<AdAccountResponse, AdAccountRequest>(
    FACEBOOK_AD_ACCOUNT_URL,
    { code },
    { retry: false, refetchOnMount: false, staleTime: Infinity },
  );

  return {
    data,
    isLoading,
    isError,
    isSuccess,
  };
};
